module.exports = __webpack_public_path__ + "static/media/palfed.7cf043e1.svg";